/**
 * MY — Change of Registered Address (M32102) 의 Register Detail 매핑.
 *
 * 키는 buildChangeAddressVariables() 출력의 snake_case 키.
 *   panel 의 handleCreateTask 가 task POST 의 officerData 로 그 commonFormData 를
 *   동봉하므로 TASK_DATA.formData 에서 그대로 추출 가능.
 */
import { registerRegisterDetail } from '@/features/startTask/preset_task/shared/preset/register/registerDetailRegistry';

registerRegisterDetail('M32102', {
  title: 'Change of Registered Office Address',
  fields: [
    // A→B 비교 — 둘 다 panel 이 만든 composed 주소(국가명 변환 완료, 코드 아님).
    { label: 'Current Address', key: ['old_registered_address', 'OLD_REGISTERED_ADDRESS'] },
    { label: 'New Address', key: ['new_registered_address', 'NEW_REGISTERED_ADDRESS'] },
    { label: 'Date of Change', key: ['date_of_change_of_address', 'date_of_change'] },
    { label: 'Date of Declaration', key: 'date_of_declaration' },
    { label: 'Date of Resolution', key: 'date_of_resolution' },
  ],
});
